module.exports = __webpack_public_path__ + "static/img/coe-4ton-yellow.b934fe2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-4ton-yellow.svg
// module id = yQ8i
// module chunks = 74